/* custom-header.js */
document.addEventListener('DOMContentLoaded', function () {
  console.log('custom-header.js loaded');

  /* ============================================================
     1. MEGA MENU (DESKTOP HOVER + MOBILE TAP)
     (Safe: runs only if nav exists)
  ============================================================ */
  const nav = document.querySelector('#custom-header .ch-category-nav');
  console.log('nav found?', !!nav);

  // Keep a callable reference so drawer can close mega menu if present
  let closeAll = function () {};

  const MOBILE_MAX = 990;
  const isHoverDevice = () => window.matchMedia('(hover: hover)').matches;
  const isMobile = () => window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;

  if (nav) {
    let closeTimer = null;
    let hoverTimer = null;

    const DESKTOP_CLOSE_DELAY = 200;
    const DESKTOP_HOVER_DELAY = 140;

    function setActiveTopItem(item) {
      if (!item) return;

      const hasMega = item.querySelector('.ch-mega-menu');
      if (!hasMega) {
        nav.querySelectorAll('.ch-cat-item--active').forEach((i) => i.classList.remove('ch-cat-item--active'));
        nav.classList.remove('is-open');
        return;
      }

      nav.querySelectorAll('.ch-cat-item--active').forEach((i) => i.classList.remove('ch-cat-item--active'));
      item.classList.add('ch-cat-item--active');
      nav.classList.add('is-open');
    }

    closeAll = function () {
      nav.querySelectorAll('.ch-cat-item--active').forEach((i) => i.classList.remove('ch-cat-item--active'));
      nav.classList.remove('is-open');

      nav.querySelectorAll('.ch-mega-left-item.is-open').forEach((it) => it.classList.remove('is-open'));
      nav
        .querySelectorAll('.ch-cat-item > a[data-ch-tap-primed], .ch-cat-item > .ch-cat-parent-btn[data-ch-tap-primed]')
        .forEach((a) => delete a.dataset.chTapPrimed);
      nav
        .querySelectorAll('.ch-mega-left-btn[data-ch-sub-primed], .ch-mega-left-link[data-ch-sub-primed]')
        .forEach((a) => delete a.dataset.chSubPrimed);
    };

    /* ---------- Desktop open/close (nav level) ---------- */
    nav.addEventListener('pointerenter', () => {
      if (!isHoverDevice()) return;
      if (closeTimer) clearTimeout(closeTimer);
    });

    nav.addEventListener('pointerleave', () => {
      if (!isHoverDevice()) return;
      if (hoverTimer) clearTimeout(hoverTimer);
      closeTimer = setTimeout(() => {
        closeAll();
      }, DESKTOP_CLOSE_DELAY);
    });

    /* ---------- Desktop hover activation (DELEGATED) ---------- */
    nav.addEventListener('mousemove', (e) => {
      if (!isHoverDevice()) return;

      const item = e.target.closest('.ch-cat-item');
      if (!item || !nav.contains(item)) return;

      const hasMega = item.querySelector('.ch-mega-menu');

      if (!hasMega) {
        if (hoverTimer) clearTimeout(hoverTimer);
        closeAll();
        return;
      }

      if (hoverTimer) clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        setActiveTopItem(item);
      }, DESKTOP_HOVER_DELAY);
    });

    /* ---------- Keyboard focus opens mega (desktop) ---------- */
    nav.addEventListener('focusin', (e) => {
      if (!isHoverDevice()) return;

      const item = e.target.closest('.ch-cat-item');
      if (!item || !nav.contains(item)) return;

      setActiveTopItem(item);
    });

    /* ============================================================
       1A. 3RD-LEVEL RIGHT PANEL SWITCHER
    ============================================================ */
    function setThirdPanel(megaMenuEl, idx, titleText) {
      if (!megaMenuEl) return;

      const panels = megaMenuEl.querySelectorAll('.ch-mega-third-list[data-third-panel]');
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.thirdPanel === String(idx)));

      const heading = megaMenuEl.querySelector('.ch-mega-third-title');
      if (heading && titleText) heading.textContent = titleText;
    }

    nav.addEventListener('pointerover', (e) => {
      if (!isHoverDevice()) return;

      const leftItem = e.target.closest('.ch-mega-left-item.has-grandchildren[data-child-index]');
      if (!leftItem || !nav.contains(leftItem)) return;

      const idx = leftItem.getAttribute('data-child-index');
      const title = leftItem.getAttribute('data-child-title');
      const mega = leftItem.closest('.ch-mega-menu--departments');

      if (idx != null && mega) setThirdPanel(mega, idx, title);
    });

    nav.addEventListener('focusin', (e) => {
      const leftItem = e.target.closest('.ch-mega-left-item.has-grandchildren[data-child-index]');
      if (!leftItem || !nav.contains(leftItem)) return;

      const idx = leftItem.getAttribute('data-child-index');
      const mega = leftItem.closest('.ch-mega-menu--departments');
      if (idx != null && mega) setThirdPanel(mega, idx);
    });

    /* ============================================================
       1B. MOBILE TOP-LEVEL TAP (OPEN ONLY) - kept (strip hidden on mobile)
    ============================================================ */
    nav.addEventListener(
      'pointerdown',
      (e) => {
        if (!isMobile()) return;

        const topTrigger = e.target.closest('.ch-cat-item > a, .ch-cat-item > .ch-cat-parent-btn');
        if (!topTrigger) return;

        const item = topTrigger.closest('.ch-cat-item');
        if (!item) return;

        const hasMega = item.querySelector('.ch-mega-menu');
        if (!hasMega) return;

        const open = item.classList.contains('ch-cat-item--active');

        if (!open) {
          e.preventDefault();
          e.stopPropagation();
          setActiveTopItem(item);
        }
      },
      { capture: true }
    );

    nav.addEventListener(
      'click',
      (e) => {
        const closeBtn = e.target.closest('.ch-mega-close');
        if (closeBtn) {
          e.preventDefault();
          e.stopPropagation();
          closeAll();
          return;
        }

        if (!isMobile()) return;

        const topLink = e.target.closest('.ch-cat-item > a');
        if (!topLink) return;

        const item = topLink.closest('.ch-cat-item');
        if (!item) return;

        const hasMega = item.querySelector('.ch-mega-menu');
        if (!hasMega) return;

        const open = item.classList.contains('ch-cat-item--active');

        if (!open) {
          e.preventDefault();
          e.stopPropagation();
          setActiveTopItem(item);
        }
      },
      { capture: true }
    );

    window.addEventListener('resize', () => {
      if (!isMobile()) closeAll();
    });

    /* ============================================================
       1D. MOBILE: 2ND-LEVEL ACCORDION (strip hidden on mobile)
    ============================================================ */
    function closeSecondLevelSiblings(scopeEl, exceptItem) {
      if (!scopeEl) return;

      scopeEl.querySelectorAll('.ch-mega-left-item.is-open').forEach((it) => {
        if (it !== exceptItem) it.classList.remove('is-open');
      });

      scopeEl
        .querySelectorAll('.ch-mega-left-btn[data-ch-sub-primed], .ch-mega-left-link[data-ch-sub-primed]')
        .forEach((a) => delete a.dataset.chSubPrimed);
    }

    function activateThirdForSecondLevel(subItem) {
      const idx = subItem ? subItem.getAttribute('data-child-index') : null;
      const mega = subItem ? subItem.closest('.ch-mega-menu--departments') : null;
      if (idx != null && mega) {
        // keep title unchanged here
        const panels = mega.querySelectorAll('.ch-mega-third-list[data-third-panel]');
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.thirdPanel === String(idx)));
      }
    }

    nav.addEventListener(
      'pointerdown',
      (e) => {
        if (!isMobile()) return;

        const subTrigger = e.target.closest(
          '.ch-mega-left-item.has-grandchildren > .ch-mega-left-btn, .ch-mega-left-item.has-grandchildren > .ch-mega-left-link'
        );
        if (!subTrigger) return;

        const subItem = subTrigger.closest('.ch-mega-left-item.has-grandchildren');
        if (!subItem) return;

        const panel = subItem.closest('.ch-mega-menu');
        const isOpen = subItem.classList.contains('is-open');

        e.preventDefault();
        e.stopPropagation();

        if (isOpen) {
          subItem.classList.remove('is-open');
          return;
        }

        closeSecondLevelSiblings(panel, subItem);
        subItem.classList.add('is-open');
        activateThirdForSecondLevel(subItem);
      },
      { capture: true }
    );

    nav.addEventListener(
      'click',
      (e) => {
        if (!isMobile()) return;

        const subTrigger = e.target.closest(
          '.ch-mega-left-item.has-grandchildren > .ch-mega-left-btn, .ch-mega-left-item.has-grandchildren > .ch-mega-left-link'
        );
        if (!subTrigger) return;

        e.preventDefault();
        e.stopPropagation();
      },
      { capture: true }
    );
  } // ✅ end if (nav)

  /* ============================================================
     1E. MOBILE HAMBURGER DRAWER (TOP SLIDE)
     (Independent: works even if nav is missing)
  ============================================================ */
  const hamburger = document.querySelector('#custom-header .ch-hamburger');
  const drawer = document.querySelector('#custom-header #ch-mobile-drawer');

  let chScrollY = 0;

  function lockScroll() {
    chScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('ch-no-scroll');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${chScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.documentElement.classList.remove('ch-no-scroll');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, chScrollY);
  }

  function openDrawer() {
    if (!drawer || !hamburger) return;
    drawer.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    lockScroll();
    // close mega menu if present
    if (typeof closeAll === 'function') closeAll();
  }

  function closeDrawer() {
    if (!drawer || !hamburger) return;
    drawer.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    unlockScroll();

    // reset all open submenus + toggles
    drawer.querySelectorAll('.ch-mobile-sub').forEach((sub) => (sub.hidden = true));
    drawer.querySelectorAll('.ch-mobile-toggle').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = '+';
    });
  }

  if (hamburger && drawer) {
    hamburger.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();

      const expanded = hamburger.getAttribute('aria-expanded') === 'true';
      if (expanded) closeDrawer();
      else openDrawer();
    });

    drawer.addEventListener('click', (e) => {
      const closeHit = e.target.closest('[data-ch-mobile-close]');
      if (closeHit) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      // close drawer on any real link click
      const linkHit = e.target.closest('a.ch-mobile-link[href]');
      if (linkHit) {
        closeDrawer();
        return;
      }

      // expand/collapse by clicking either the + button OR the text button (no-link)
      const hit = e.target.closest('.ch-mobile-toggle, .ch-mobile-link--nolink');
      if (!hit) return;

      e.preventDefault();

      const parentItem = hit.closest('.ch-mobile-item, .ch-mobile-subitem');
      if (!parentItem) return;

      const sub = parentItem.querySelector(':scope > .ch-mobile-sub');
      if (!sub) return;

      const isOpen = !sub.hidden;
      sub.hidden = isOpen;

      const toggleBtn = parentItem.querySelector(':scope > .ch-mobile-row .ch-mobile-toggle');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', String(!isOpen));
        toggleBtn.textContent = isOpen ? '+' : '–';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!drawer.classList.contains('is-open')) return;
      closeDrawer();
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) closeDrawer();
    });
  }

  /* ============================================================
     2. PREDICTIVE SEARCH (PRODUCTS + PAGES)
  ============================================================ */
  const searchWrappers = document.querySelectorAll('[data-predictive-search]');
  if (searchWrappers.length) {
    searchWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('input[type="search"]');
      const suggestions = wrapper.querySelector('.ch-search-suggestions');
      const form = wrapper.querySelector('form');

      if (!input || !suggestions || !form) return;

      let debounceTimer = null;
      const supportsAbort = typeof AbortController !== 'undefined';
      let abortController = null;

      function clearSuggestions() {
        suggestions.innerHTML = '';
        suggestions.hidden = true;
      }

      function renderSuggestions(data, query) {
        const results = data && data.resources && data.resources.results ? data.resources.results : {};
        const products = (results.products || []).slice(0, 5);
        const pages = (results.pages || []).slice(0, 3);

        let html = '';

        html += `
          <div class="ch-suggest-group">
            <div class="ch-suggest-heading">Search</div>
            <ul class="ch-suggest-list">
              <li class="ch-suggest-item">
                <a href="/search?q=${encodeURIComponent(query)}">
                  <span class="ch-suggest-text">Search for “${query}”</span>
                </a>
              </li>
              <li class="ch-suggest-item ch-suggest-item--all">
                <a href="/search?q=${encodeURIComponent(query)}" class="ch-suggest-all-link">
                  <span class="ch-suggest-all-text">View all results</span>
                  <span class="ch-suggest-all-arrow" aria-hidden="true">→</span>
                </a>
              </li>
            </ul>
          </div>
        `;

        if (products.length) {
          html += `
            <div class="ch-suggest-group">
              <div class="ch-suggest-heading">Products</div>
              <ul class="ch-suggest-list">
          `;

          products.forEach((p) => {
            const title = p.title || '';
            const url = p.url || '#';
            const image =
              (p.image && typeof p.image === 'string' && p.image) ||
              (p.featured_image && p.featured_image.url) ||
              null;

            html += `
              <li class="ch-suggest-item">
                <a href="${url}">
                  ${image ? `<span class="ch-suggest-thumb"><img src="${image}" alt="${title}"></span>` : ''}
                  <span class="ch-suggest-text">${title}</span>
                </a>
              </li>
            `;
          });

          html += `</ul></div>`;
        } else {
          html += `
            <div class="ch-suggest-group">
              <div class="ch-suggest-heading">Products</div>
              <ul class="ch-suggest-list">
                <li class="ch-suggest-item">
                  <a href="/search?q=${encodeURIComponent(query)}">
                    <span class="ch-suggest-text">No products found</span>
                  </a>
                </li>
              </ul>
            </div>
          `;
        }

        if (pages.length) {
          html += `
            <div class="ch-suggest-group">
              <div class="ch-suggest-heading">Services</div>
              <ul class="ch-suggest-list">
          `;

          pages.forEach((pg) => {
            const title = pg.title || '';
            const url = pg.url || '#';

            html += `
              <li class="ch-suggest-item">
                <a href="${url}">
                  <span class="ch-suggest-text">${title}</span>
                </a>
              </li>
            `;
          });

          html += `</ul></div>`;
        } else {
          html += `
            <div class="ch-suggest-group">
              <div class="ch-suggest-heading">Pages</div>
              <ul class="ch-suggest-list">
                <li class="ch-suggest-item">
                  <a href="/search?q=${encodeURIComponent(query)}">
                    <span class="ch-suggest-text">No pages found</span>
                  </a>
                </li>
              </ul>
            </div>
          `;
        }

        suggestions.innerHTML = html;
        suggestions.hidden = false;
      }

      function fetchSuggestions(query) {
        const q = (query || '').trim();
        if (q.length < 2) {
          clearSuggestions();
          return;
        }

        if (supportsAbort && abortController) abortController.abort();
        abortController = supportsAbort ? new AbortController() : null;

        const url =
          `/search/suggest.json?q=${encodeURIComponent(q)}` +
          `&resources[type]=product,page` +
          `&resources[limit]=5` +
          `&resources[options][unavailable_products]=hide` +
          `&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku`;

        const fetchOptions = abortController ? { signal: abortController.signal } : {};

        fetch(url, fetchOptions)
          .then((res) => res.json())
          .then((data) => renderSuggestions(data, q))
          .catch((err) => {
            if (supportsAbort && err.name === 'AbortError') return;
            clearSuggestions();
          });
      }

      input.addEventListener('input', () => {
        const value = input.value;
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => fetchSuggestions(value), 200);
      });

      input.addEventListener('focus', () => {
        const value = input.value;
        if (value.trim().length >= 2) fetchSuggestions(value);
      });

      input.addEventListener('blur', () => setTimeout(clearSuggestions, 150));

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          clearSuggestions();
          input.blur();
        }
      });

      form.addEventListener('submit', clearSuggestions);
    });
  }

  /* ============================================================
     3. CART COUNT LIVE UPDATE (HORIZON-SAFE)
  ============================================================ */
  function getCartCountEl() {
    return document.querySelector('.ch-cart-count');
  }

  async function refreshCartCount() {
    const cartCountEl = getCartCountEl();
    if (!cartCountEl) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;

      const cart = await res.json();
      const count = Number(cart.item_count || 0);

      cartCountEl.textContent = count;
      if (count > 0) cartCountEl.removeAttribute('hidden');
      else cartCountEl.setAttribute('hidden', 'hidden');
    } catch (_) {}
  }

  refreshCartCount();
  window.addEventListener('pageshow', refreshCartCount);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshCartCount();
  });

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('input[name="id"]')) return;

      setTimeout(refreshCartCount, 250);
      setTimeout(refreshCartCount, 900);
      setTimeout(refreshCartCount, 1600);
    },
    true
  );

  const _fetch = window.fetch;
  window.fetch = function (...args) {
    return _fetch.apply(this, args).then((response) => {
      try {
        const url = args[0] && args[0].url ? args[0].url : String(args[0] || '');
        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        ) {
          setTimeout(refreshCartCount, 150);
          setTimeout(refreshCartCount, 700);
        }
      } catch (_) {}
      return response;
    });
  };

  (function patchXHR() {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__ch_url = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener('loadend', () => {
        const url = String(this.__ch_url || '');
        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        ) {
          setTimeout(refreshCartCount, 150);
          setTimeout(refreshCartCount, 700);
        }
      });
      return origSend.apply(this, args);
    };
  })();

  window.addEventListener('cart:updated', refreshCartCount);
  window.addEventListener('cart:refresh', refreshCartCount);
  document.addEventListener('theme:cart:update', refreshCartCount);

  if (window.PubSub && typeof window.PubSub.subscribe === 'function') {
    window.PubSub.subscribe('cart-update', refreshCartCount);
    window.PubSub.subscribe('cart:updated', refreshCartCount);
  }

  /* ============================================================
     4. SKU LIVE UPDATE
  ============================================================ */
  (function initSkuLiveUpdate_VariantPickerForm() {
    const skuWrapper = document.querySelector('.product-sku');
    const skuValueEl =
      document.querySelector('.product-sku__value') || (skuWrapper ? skuWrapper.querySelector('span') : null);

    const pickerForm = document.querySelector('form.variant-picker__form');
    if (!skuWrapper || !skuValueEl || !pickerForm) return;

    const skuCache = new Map();

    async function fetchSku(variantId) {
      if (!variantId) return '';
      const key = String(variantId);
      if (skuCache.has(key)) return skuCache.get(key);

      try {
        const res = await fetch(`/variants/${key}.js`, { credentials: 'same-origin' });
        if (!res.ok) return '';
        const v = await res.json();
        const sku = v && v.sku ? String(v.sku) : '';
        skuCache.set(key, sku);
        return sku;
      } catch (_) {
        return '';
      }
    }

    function getCheckedVariantId() {
      const checked = pickerForm.querySelector('input[type="radio"][data-variant-id]:checked');
      return checked ? checked.getAttribute('data-variant-id') : null;
    }

    async function updateSku() {
      const variantId = getCheckedVariantId();
      const sku = await fetchSku(variantId);

      if (sku) {
        skuValueEl.textContent = sku;
        skuWrapper.style.display = '';
      } else {
        skuValueEl.textContent = '';
        skuWrapper.style.display = 'none';
      }
    }

    updateSku();

    pickerForm.addEventListener('change', (e) => {
      if (e.target && e.target.matches('input[type="radio"][data-variant-id]')) {
        updateSku();
      }
    });
  })();
});
